import { UikitProvider } from "@dutyon/ui-kit";
import { NuqsAdapter } from "nuqs/adapters/react";
import type { PropsWithChildren } from "react";

export const RootProvider = ({ children }: PropsWithChildren) => {
  return (
    <UikitProvider>
      <NuqsAdapter>{children}</NuqsAdapter>
    </UikitProvider>
  );
};
